jQuery(function ($) {
    let $sectionWrapper = $('.vaardigheidsniveau');

    if ($sectionWrapper.length === 0 && $(window).width() > 767) {
        return; 
    }

    $('.vaardigheidsniveau__switch').on('click', function(){
        let $switch = $(this);
        let target = $switch.data('target');
        let $targetEl = $('#' + target);

        $('.vaardigheidsniveau__item').removeClass('active');
        $targetEl.addClass('active');

        // Scroll to target on mobile
        if ($(window).width() <= 767) {
            $('html, body').animate({
                scrollTop: $targetEl.offset().top - 20 // adjust offset if needed
            }, 400);
        }
    });
});
